import { FunctionComponent } from "react";
import BasicFinancialQuizForm from "src/components/forms/quizz/BasicFinancialQuizForm";
import MobileNav from "src/components/navigation/MobileNav";
import TopNav from "src/components/navigation/TopNav";
import Footer from "src/components/website/Footer";


const BasicFinancialQuiz: FunctionComponent = () => (
    <div className="max-w-[1440px] mx-auto w-full min-h-screen">
        <TopNav />
        <MobileNav />
        <BasicFinancialQuizForm />
        <Footer />
    </div>  
);

export default BasicFinancialQuiz;